import { createSlice } from "@reduxjs/toolkit";

const reconciliationSlice = createSlice({
  name: "reconciliation",
  initialState: {
    loading: false,
    error: null,
    reconciliation: [],
    totalCount: {},
    reconciliationProfileUiid: null,
    currentReconciliation: {
      reconciliationDetails: {},
      loadedTabs: [],
    }, // Add this for single employee data
  },
  reducers: {
    clearReconciliationData(state) {
      state.reconciliation = [];
      state.totalCount = {};
      state.reconciliationProfileUiid = null;
      state.currentReconciliation = {
        reconciliationDetails: {},
        loadedTabs: [],
      };
    },
    clearReconciliationProfile(state) {
      state.reconciliationProfileUiid = null;
      state.currentReconciliation = {
        reconciliationDetails: {},
        loadedTabs: [],
      };
    },
    getReconciliationsStart(state, action) {
      const { limit, page, employmentType } = action.payload;
      state.loading = true;
    },
    getReconciliationsSuccess(state, action) {
      state.loading = false;
      state.reconciliation = action.payload.data; // Store paginated data
      state.totalCount = action.payload.totalCount; // Store total count
    },
    getReconciliationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.reconciliation = [];
      state.totalCount = null;
    },
    // Add Client
    addNewReconciliationStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewReconciliationSuccess(state, action) {
      state.reconciliationProfileUiid = action.payload.data.uiid;
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addNewReconciliationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateReconciliationStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateReconciliationSuccess(state, action) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateReconciliationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getReconciliationOneStart(state) {
      state.loading = true;
      state.error = null;
    },
    getReconciliationOneSuccess(state, action) {
      state.loading = false;
      state.reconciliationProfileUiid = action.payload.data.uiid
        ? action.payload.data.uiid
        : state.reconciliationProfileUiid;
      state.currentReconciliation.reconciliationDetails = {
        ...state.currentReconciliation.reconciliationDetails,
        ...action.payload.data,
      };
      state.draft = null;
      state.lastSaved = null;
    },
    getReconciliationOneFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCurrentReconciliation(state) {
      state.currentReconciliation = {
        reconciliationDetails: {},
        loadedTabs: [],
      };
    },
  },
});

export const {
  clearReconciliationData,
    clearReconciliationProfile,
    getReconciliationsStart,
    getReconciliationsSuccess,
    getReconciliationsFailure,
    addNewReconciliationStart,
    addNewReconciliationSuccess,
    addNewReconciliationFailure,
    updateReconciliationStart,
    updateReconciliationSuccess,
    updateReconciliationFailure,
    getReconciliationOneStart,
    getReconciliationOneSuccess,
    getReconciliationOneFailure,
    resetCurrentReconciliation
} = reconciliationSlice.actions;
export default reconciliationSlice.reducer;
